import * as React from "react";
import { DropDownListComponent } from "../../dropdownlist/dropdownlistcomponent";
import { DropDownListCSSStyleImpl } from "../../dropdownlist/dropdownlistcss";
import { SelectComponentProps, SelectComponentState, SelectComponentHandler } from "../selectcomponent";
import { SelectCSSStyle } from "../selectcss";
import { SelectViewImpl } from "../selectview";
import './profiletune-select-style.css';

export class ProfileTuneSelectViewImpl extends SelectViewImpl
{
    bindHandlers()
    {
        this.showDropDown = this.showDropDown.bind(this);
        this.hideDropDown =  this.hideDropDown.bind(this);
    }

    draw(props: SelectComponentProps, state: SelectComponentState, cssStyle: SelectCSSStyle): JSX.Element | boolean
    {   
        console.log("onOptionSelected: " +state.id + ", : " + state.value);
         return (
                <div style={cssStyle.getWrapperCSSStyle()}>
                    {/* <label style={cssStyle.getSelectLabelCSSStyle()}>{props.placeholder}
                        <label style={cssStyle.getLabelStartCSSStyle()}>
                           {"*"}
                        </label>
                    </label>               */}
                    <input disabled={true} value={state.value} type={"text"} style={cssStyle.getTextCSSStyle(true , false)} placeholder={props.placeholder}/>
                    <img style={{cursor: "pointer", height: "14px", width: "13px", position: "relative", right: "30px"}} onClick={this.showDropDown} src={props.context.getResources().getImage("down_arrow.svg")}/>
                    {
                        state.errorMessage !== undefined && <div style={cssStyle.getErrorTextDivCSSStyle()}>
                        <label id="Profile-select-error-label" style={cssStyle.getErrorTextCSSStyle(this.getContext().getUserContext().getLanguage())}>{state.errorMessage}</label> </div>}
                    {
                        props.listViewModel.getListOfDatas().length > 0 && state.isDropDownShow &&
                        <div id="Profile-select-dropdown" onMouseLeave={this.hideDropDown} style={cssStyle.getDropDownSSStyle()}>
                        <DropDownListComponent cssStyle={new DropDownListCSSStyleImpl(this.getContext())} listViewModel={props.listViewModel} context={props.context}/>
                        </div>}
                </div>
       );
    }

    protected hideDropDown()
    {
        (this.getUIComponentHandler() as SelectComponentHandler).toggleDropDown(false);
    }
    protected showDropDown() 
    {
        (this.getUIComponentHandler() as SelectComponentHandler).toggleDropDown(true);
    }
    
   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/select/profiletuneselect/profiletuneselectview.tsx